import { render } from "./Test.vue?vue&type=template&id=796343ba&scoped=true"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"

import "./Test.vue?vue&type=style&index=0&id=796343ba&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-796343ba"

export default script